import React, { FC } from 'react';
import { Clock } from '../clock';
import { l10n } from '../with-app-root/i18n/i18nUtil';

interface Props {
  text?: string;
}

const styleOuter = {
  display: 'inline-flex',
  alignItems: 'center'
};

const styleClock = {
  marginRight: '0.5rem'
};

const ClockLoader: FC<Props> = props => {
  const { text } = props;
  return (
    <span style={styleOuter}>
      <span style={styleClock}>
        <Clock />
      </span>
      {text || `${l10n('pleaseWait')}...`}
    </span>
  );
};

export default ClockLoader;
